<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.763 7.79031H17.513V4.04031"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.13864 5.13864C5.77704 4.50024 6.53494 3.99383 7.36905 3.64833C8.20316 3.30283 9.09716 3.125 10 3.125C10.9028 3.125 11.7968 3.30283 12.6309 3.64833C13.4651 3.99383 14.223 4.50024 14.8614 5.13864L17.513 7.79029"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.23695 12.2097H2.48695V15.9597"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8614 14.8614C14.223 15.4998 13.4651 16.0062 12.6309 16.3517C11.7968 16.6972 10.9028 16.875 10 16.875C9.09716 16.875 8.20316 16.6972 7.36905 16.3517C6.53494 16.0062 5.77704 15.4998 5.13864 14.8614L2.48699 12.2097"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
